/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { DataContextProvider } from '@forge/data-connector';
import PortfolioSummaryComponent from './PortfolioSummaryComponent';
import IEnergyManagementProps from '../IEnergyManagementProps';

const PortfolioSummaryWidget = (props: IEnergyManagementProps) => {
  const { bearerToken, requestContext, connectorConfig } = props;
  return (
    <div>
      <DataContextProvider config={connectorConfig}>
        <PortfolioSummaryComponent
          requestContext={requestContext}
          bearerToken={bearerToken}
          connectorConfig={connectorConfig}
        />
      </DataContextProvider>
    </div>
  );
};
export default PortfolioSummaryWidget;
